<template>
  <div class="questionnaire_subjects_container">
    <div class="subjects_box">
      <div class="detail_box">
        <div class="title"><span>参与问卷：</span><span v-text="detail.title"></span></div>
        <div class="time">
          <Icon iconClass="time" /><span v-text="time"></span>
        </div>
      </div>
      <div class="userInfo_box" v-if="detail.isMemberInfo && !!memberFields">
        <div class="userInfo_title">
          <div class="title">答卷人基本信息</div>
        </div>
        <div class="member_field_box">
          <div class="member_field_form_list">
            <div class="member_field_form_item" v-if="memberFields.isMemberName">
              <div class="member_field_form_item_title">
                <span class="name">姓名</span>
              </div>
              <div class="member_field_form_item_body">
                <input type="text" placeholder="请填写您的姓名" v-model="fieldValues.memberName" class="member_field_input_text">
              </div>
            </div>
            <div class="member_field_form_item" v-if="memberFields.isMemberPhone">
              <div class="member_field_form_item_title">
                <span class="name">手机号</span>
              </div>
              <div class="member_field_form_item_body">
                <input type="text" placeholder="请填写您的手机号" v-model="fieldValues.memberPhone" class="member_field_input_text">
              </div>
            </div>
            <div class="member_field_form_item" v-if="memberFields.isOrganization">
              <div class="member_field_form_item_title">
                <span class="name">单位</span>
              </div>
              <div class="member_field_form_item_body">
                <input type="text" placeholder="请填写您的单位全称" v-model="fieldValues.organization" class="member_field_input_text">
              </div>
            </div>
            <div class="member_field_form_item" v-if="memberFields.isDepartment">
              <div class="member_field_form_item_title">
                <span class="name">部门</span>
              </div>
              <div class="member_field_form_item_body">
                <input type="text" placeholder="请填写您的部门名称" v-model="fieldValues.department" class="member_field_input_text">
              </div>
            </div>
            <div class="member_field_form_item item_no_border" v-if="memberFields.isOrganizationCode">
              <div class="member_field_form_item_title">
                <span class="name">单位代码</span>
              </div>
              <div class="member_field_form_item_body">
                <input type="text" placeholder="请填写您的单位代码" v-model="fieldValues.organizationCode" class="member_field_input_text">
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="questions" v-if="itemList.length>0">
        <li class="question_title">
          <div class="title">调查问卷</div>
        </li>
        <li class="question_item" v-for="(item,index) in itemList" :key="index">
          <div class="title">
            {{ ( index + 1 ) }}、{{ item.type == 3 ? item.fillingTitle : item.title }}
            <label class="required" v-if="item.isAnswer">*</label>
            <label class="item_type">【{{getItemTypeLabel(item.type)}}】</label>
            <label class="score" v-if="detail.isGrade">{{ item.score }}分</label>
          </div>
          <!-- 单选 -->
          <div class="question_body" v-if="item.type==1">
            <div class="radio_list radio_img_list clearfix" v-if="item.supportPicture==1">
              <div :class="{radio:true,checked:opt.checked}" v-for="( opt, n ) in item.options" :key="n" @click="onRadioClick(item.options,opt);">
                <div class="radio_img_box">
                  <div class="img">
                    <img :src="opt.dataPath" alt="" v-if="opt.dataPath && opt.dataPath.length>0">
                    <img :src="require('@/assets/images/default_pic_4_3.png')" alt="" v-else />
                  </div>
                </div>
                <input type="radio" :name="'radioGorup' + item.subjectId" :checked="opt.checked">
                <div class="info">
                  <span class="title_text">{{opt.itemTitle}}</span>
                </div>
              </div>
            </div>
            <div class="radio_list" v-else>
              <div :class="{radio:true,checked:opt.checked}" v-for="( opt, n ) in item.options" :key="n" @click="onRadioClick(item.options,opt);">
                <input type="radio" :name="'radioGorup' + item.subjectId" :checked="opt.checked">
                <label>
                  <span class="num_text">{{getSelectLabel(n)}}</span><span class="title_text">{{opt.itemTitle}}</span>
                </label>
              </div>
            </div>
          </div>
          <!-- 多选 -->
          <div class="question_body" v-if="item.type==2">
            <div class="check_list check_img_list clearfix" v-if="item.supportPicture==1">
              <div :class="{checkbox:true,checked:opt.checked}" v-for="(opt,n) in item.options" :key="n" @click="onCheckClick(opt);">
                <div class="check_img_box">
                  <div class="img">
                    <img :src="opt.dataPath" alt="" v-if="opt.dataPath && opt.dataPath.length>0">
                    <img :src="require('@/assets/images/default_pic_4_3.png')" alt="" v-else />
                  </div>
                </div>
                <input type="checkbox" :name="'checkboxGorup' + item.subjectId" :checked="opt.checked">
                <div class="info">
                  <span class="title_text">{{opt.itemTitle}}</span>
                </div>
              </div>
            </div>
            <div class="check_list" v-else>
              <div :class="{checkbox:true,checked:opt.checked}" v-for="(opt,n) in item.options" :key="n" @click="onCheckClick(opt);">
                <input type="checkbox" :name="'checkboxGorup' + item.subjectId" :checked="opt.checked">
                <label>
                  <span class="num_text">{{getSelectLabel(n)}}</span><span class="title_text">{{opt.itemTitle}}</span>
                </label>
              </div>
            </div>
          </div>
          <!-- 填空 -->
          <div class="question_body" v-if="item.type==3">
            <div class="fill" v-html="getBlockHTML( item.title, item.subjectId )"></div>
          </div>
          <!-- 问答 -->
          <div class="question_body" v-if="item.type==4">
            <textarea :placeholder="getPlaceholder( item )" v-model="item.value"></textarea>
          </div>
          <!-- 判断 -->
          <div class="question_body" v-if="item.type==5">
            <div class="judge_list">
              <div :class="{judge:true,split_line:true,checked:item.value=='1'}" @click="item.value='1'">
                <input type="radio" :name="'radioGorup' + item.subjectId" :checked="item.value=='1'">
                <label><span class="title_text">对</span></label>
              </div>
              <div :class="{judge:true,checked:item.value=='0'}" @click="item.value='0'">
                <input type="radio" :name="'radioGorup' + item.subjectId" :checked="item.value=='0'">
                <label><span class="title_text">错</span></label>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="submit_btn_box">
        <span class="submit_btn" @click="onQuestionSubmit">提 交</span>
      </div>
    </div>
    <van-popup :style="{ width: '80%', background: 'none' }" v-model="showResult">
      <div class="result_box" v-if="!!result">
        <!-- 支持打分  -->
        <div class="result_score_box" v-if="detail.isGrade">
          <div class="result_img_box" v-if="(detail.relatedGradeDrawId>0) && (!detail.isGradeDraw || (detail.drawMingrade<result.score))">
            <img :src="require('@/assets/images/activity/score_raffle.png')" alt="">
            <span class="result_close" @click="finish"></span>
            <span class="result_score" v-text="result.score" v-if="!!result"></span>
            <span class="btn_raffle" @click="raffle(true)"></span>
            <span class="btn_close" @click="finish"></span>
          </div>
          <div class="result_img_box" v-else>
            <img :src="require('@/assets/images/activity/score.png')" alt="">
            <span class="result_close" @click="finish"></span>
            <span class="result_score" v-text="result.score" v-if="!!result"></span>
            <span class="btn_confirm" @click="finish"></span>
          </div>
        </div>
        <!-- 不支持打分 -->
        <div class="result_thanks_box" v-else>
          <div class="result_img_box" v-if="detail.isSubmitDraw && detail.relatedSubmitDrawId>0">
            <img :src="require('@/assets/images/activity/thanks_raffle.png')" alt="">
            <span class="btn_raffle" @click="raffle(false)"></span>
            <span class="btn_close" @click="finish"></span>
          </div>
          <div class="result_img_box" v-else>
            <img :src="require('@/assets/images/activity/thanks.png')" alt="">
            <span class="btn_confirm" @click="finish"></span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { deepClone, getSelectLabel } from "@/utils";
import { mapState } from "vuex";
import qsApi from "@/api/apis/questionnaire.js";
export default {
  name: "Subjects",
  data() {
    return {
      detail: null,
      itemList: [], // 题库
      memberFields: null, // 自定义字段表单
      /* 自定义字段 */
      fieldValues: {
        memberName: "",
        memberPhone: "",
        organization: "",
        department: "",
        isOrganizationCode: "",
      },
      showResult: false,
      result: null,
    };
  },
  props: {
    params: {
      type: Object,
      default: {
        contentType: 10,
        id: null,
        cId: null,
      },
    },
    detailInfo: {
      type: Object,
      default: null,
    },
    mainbodyId: {
      type: Number,
      default: null,
    }
  },
  watch: {
    detailInfo: {
      handler(newValue, oldValue) {
        this.detail = deepClone(newValue);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("app", ["userInfo"]),
    /* 答题时间 */
    time() {
      let time = this.detail.startDate + " " + this.detail.startTime;
      time += " - ";
      time += this.detail.endDate + " " + this.detail.endTime;
      return time;
    },
  },
  methods: {
    showWarning(msg) {
      this.$toast({
        message: msg,
        position: "center",
      });
    },
    /* 题目类型 */
    getItemTypeLabel(type) {
      if (1 == type) return "单选题";
      if (2 == type) return "多选题";
      if (3 == type) return "填空题";
      if (4 == type) return "问答题";
      if (5 == type) return "判断题";
    },
    /* 单选/多选编号，A、B、C、D */
    getSelectLabel(n) {
      return getSelectLabel(n);
    },
    /* 问答题 placeholder */
    getPlaceholder(item) {
      var min = item.minWordcount;
      var max = item.maxWordcount;
      if (min == 0 && max == 0) return "";
      var str = "请输入";
      if (min > 0) str += "不少于" + min + "个字";
      if (max > 0)
        str += (str == "请输入" ? "" : "，") + max + "个字以内的内容";
      return str;
    },
    /* 填空 */
    getBlockHTML(str, subjectId) {
      return str.replace(
        /<BLOCK><\/BLOCK>/g,
        '<input type="text" name="fill' + subjectId + '" class="fill_input">'
      );
    },
    /* 单选框组，选择操作 */
    onRadioClick(options, option) {
      if (option.checked == false) {
        option.checked = true;
        for (var i = 0; i < options.length; i++) {
          if (option.itemId != options[i].itemId) {
            options[i].checked = false;
          }
        }
      }
    },
    /* 多选框组，选择操作 */
    onCheckClick(option) {
      if (option.checked) {
        option.checked = false;
      } else {
        option.checked = true;
      }
    },
    /* 获取调查问卷的自定义字段 */
    getCustomMemberFields() {
      var _this = this;
      var params = {
        memberId: _this.userInfo.id,
        questionnaireId: _this.params.id,
      };
      qsApi
        .getCustomMemberFields(params)
        .then((res) => {
          _this.memberFields = res.data;
          _this.fieldValues.memberName = _this.userInfo.nickName;
          _this.fieldValues.memberPhone = _this.userInfo.mobilePhone;
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取题目列表 */
    getQuestionnaireSubjects() {
      var _this = this;
      var params = {
        memberId: _this.userInfo.id,
        questionnaireId: _this.params.id,
      };
      qsApi
        .getQuestionnaireSubjects(params)
        .then((res) => {
          let list = res.data.list;
          list.forEach(function (item, i) {
            // 单选和多选
            if (item.type == 1 || item.type == 2) {
              item.options.forEach(function (option, j) {
                option.checked = false;
              });
            }
            // 填空
            else if (item.type == 3) {
            }
            // 问答
            else if (item.type == 4) {
              item.value = "";
            }
            // 判断
            else if (item.type == 5) {
              item.value = "1";
            }
          });
          _this.itemList = list;
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 提交问卷 */
    onQuestionSubmit() {
      var _this = this;
      var params = {
        memberId: _this.userInfo.id, // 会员Id
        memberInfo: null, // 会员信息
        questionnaireId: _this.params.id, // 问卷Id
        subjectValue: [], // 主体答案
      };

      if (_this.mainbodyId != null) {
        params.mainbodyId = _this.mainbodyId;
      }

      var member = {};
      if (_this.detail.isMemberInfo && !!_this.memberFields) {
        if (_this.memberFields.isMemberName) {
          member.memberName = _this.fieldValues.memberName;
        }
        if (_this.fieldValues.memberPhone) {
          member.memberPhone = _this.fieldValues.memberPhone;
        }
        if (_this.fieldValues.organization) {
          member.organization = _this.fieldValues.organization;
        }
        if (_this.fieldValues.department) {
          member.department = _this.fieldValues.department;
        }
        if (_this.fieldValues.organizationCode) {
          member.organizationCode = _this.fieldValues.organizationCode;
        }
        params.memberInfo = member;
      }

      params.memberInfo = JSON.stringify(member);

      for (var i = 0; i < _this.itemList.length; i++) {
        let item = _this.itemList[i];
        var question = {
          subtopic_id: item.subjectId,
          value: "",
        };
        // 单选
        if (1 == item.type) {
          item.options.forEach(function (opt, j) {
            if (opt.checked) {
              question.value = opt.itemId;
            }
          });
          if (item.isAnswer && !question.value) {
            _this.showWarning("题目" + (i + 1) + "是必答题，请作答后再提交。");
            return;
          }
        }
        // 多选
        else if (2 == item.type) {
          var ids = [];
          item.options.forEach(function (opt, j) {
            if (opt.checked) {
              ids.push(opt.itemId);
            }
          });
          question.value = ids.toString();
          if (item.isAnswer && !question.value) {
            _this.showWarning("题目" + (i + 1) + "是必答题，请作答后再提交。");
            return;
          }
        }
        // 填空
        else if (3 == item.type) {
          var list = [];
          var fillDoms = document.getElementsByName("fill" + item.subjectId);
          fillDoms.forEach(function (dom, index) {
            var str = dom.value.replace(/^\s+|\s+$/g, "");
            if (item.isAnswer && "" == str) {
              _this.showWarning(
                "题目" + (i + 1) + "是必答题，请填写所有空格。"
              );
              return;
            }
            list.push({ answer: str });
          });
          question.value = list;
        }
        // 问答
        else if (4 == item.type) {
          question.value = item.value;
          if (item.isAnswer) {
            question.value = question.value.replace(/^\s+|\s+$/g, "");
            /** 判断字数限制 **/
            var min = item.minWordcount;
            var max = item.maxWordcount;
            if (min > 0 && question.value.length < min) {
              _this.showWarning(
                "题目" + (i + 1) + "，您输入的字不足" + min + "个。"
              );
              return;
            } else if (max > 0 && question.value.length > max) {
              _this.showWarning(
                "题目" + (i + 1) + "，您输入的字超过了" + max + "个。"
              );
              return;
            }
          }
        }
        // 判断
        else if (5 == item.type) {
          question.value = item.value;
          if (item.isAnswer && !question.value) {
            _this.showWarning("题目" + (i + 1) + "是必答题，请作答后再提交。");
            return;
          }
        }
        params.subjectValue.push(question);
      }

      params.subjectValue = JSON.stringify(params.subjectValue);

      qsApi
        .addQuestionAnswer(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.result = res.data;
            _this.showResult = true;
          } else if (res.suc == 0 && res.message == '您已提交过一份答卷') {
            _this.$dialog
              .alert({ message: res.message })
              .then(() => {
                _this.$emit("alreadySubmited");
              });
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 抽奖 */
    raffle(isScoreRaffle) {
      /* 打分 */
      if (isScoreRaffle) {
        this.$router.push({
          path: "/raffle_detail",
          query: {
            contentType: 2,
            freeFlag: 1,
            drawRaffleId: this.detail.relatedGradeDrawId,
            type: this.detail.gradeRaffleType
          },
        });
      } else {
        this.$router.push({
          path: "/raffle_detail",
          query: {
            contentType: 2,
            freeFlag: 1,
            drawRaffleId: this.detail.relatedSubmitDrawId,
            type: this.detail.submitRaffleType
          },
        });
      }
    },
    /* 关闭，确定，放弃抽奖 */
    finish() {
      this.showResult = false;
      this.$emit("submited", this.result);
    }
  },
  created() {
    this.detail = deepClone(this.detailInfo);
    if (this.detail.isMemberInfo) {
      this.getCustomMemberFields(); // 获取调查问卷的自定义字段
    }
    this.getQuestionnaireSubjects(); // 获取题目列表
  },
};
</script>
<style scoped lang="scss">
.questionnaire_subjects_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: auto;
  .subjects_box {
    .detail_box {
      padding: 10px 15px;
      background: #fff;
      .title {
        padding: 5px 0 10px;
        line-height: 24px;
        color: #333;
        font-size: 18px;
        font-weight: bold;
      }
      .time {
        line-height: 24px;
        color: #666;
        font-size: 16px;
        .tj-svg-icon {
          color: #a6a6a6;
          margin-right: 5px;
          font-size: 18px;
        }
      }
    }
    .userInfo_box {
      padding: 10px 15px;
      background: #fff;
      margin-top: 5px;
      .userInfo_title {
        line-height: 24px;
        .title {
          position: relative;
          padding-left: 10px;
          color: #333;
          font-size: 16px;
          font-weight: bold;
          &::before {
            position: absolute;
            left: 0;
            top: 4px;
            display: block;
            width: 4px;
            height: 16px;
            background-color: #397ef5;
            content: "";
          }
        }
      }
      .member_field_box {
        position: relative;
        width: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #fff;
        .member_field_form_list {
          padding: 5px 0;
          .member_field_form_item {
            border-bottom: 1px solid #ececec;
            &.item_no_border {
              border: none;
            }
            .member_field_form_item_title {
              line-height: 36px;
              color: #333;
              font-size: 18px;
              .name {
                font-size: 18px;
              }
            }
            .member_field_form_item_body {
              .member_field_input_text {
                color: #333;
                width: 100%;
                padding: 5px 0px;
                margin-bottom: 10px;
                border: none;
              }
            }
          }
        }
      }
    }
    .questions {
      padding: 10px 15px;
      background: #fff;
      margin-top: 5px;
      .question_title {
        line-height: 24px;
        margin-bottom: 10px;
        .title {
          position: relative;
          padding-left: 10px;
          color: #333;
          font-size: 16px;
          font-weight: bold;
          &::before {
            position: absolute;
            left: 0;
            top: 4px;
            display: block;
            width: 4px;
            height: 16px;
            background-color: #397ef5;
            content: "";
          }
        }
      }
      .question_item {
        padding-bottom: 5px;
        .title {
          line-height: 24px;
          text-align: justify;
          color: #333;
          font-weight: bold;
          .required {
            color: red;
          }
          .score {
            float: right;
            color: red;
          }
        }
        .question_body {
          margin-top: 8px;
          .radio_list {
            margin-bottom: 10px;
            .radio {
              line-height: 24px;
              padding: 8px 10px;
              border: 2px solid #ececec;
              border-radius: 5px;
              margin-bottom: 15px;
              &.checked {
                border-color: #397ef5;
              }
              label {
                .num_text {
                  margin-left: 5px;
                }
                .title_text {
                  margin-left: 5px;
                }
              }
            }
            /deep/img {
              max-width: 100%;
            }
            &.radio_img_list {
              .radio {
                float: left;
                position: relative;
                width: calc(50% - 7.5px);
                padding: 0;
                border-width: 1px;
                border-radius: 8px;
                overflow: hidden;
                &:nth-child(2n + 1) {
                  margin-right: 15px;
                }
                .radio_img_box {
                  position: relative;
                  width: 100%;
                  height: 0;
                  padding-bottom: 75%;
                  background-color: #fff;
                  .img {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                    img {
                      display: block;
                      width: 100%;
                      height: 100%;
                    }
                  }
                }
                input[type="radio"] {
                  display: none;
                }
                &::after {
                  position: absolute;
                  right: 0;
                  top: -1px;
                  display: block;
                  width: 30px;
                  height: 30px;
                  z-index: 2;
                  background-image: url(~@/assets/images/icon_unselect.png);
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size: contain;
                  content: "";
                }
                &.checked {
                  &::after {
                    background-image: url(~@/assets/images/icon_select.png);
                  }
                }
              }
              .info {
                padding: 5px 12px 5px;
                line-height: 21px;
                .title_text {
                  color: #333;
                  font-size: 14px;
                }
              }
            }
          }
          .check_list {
            margin-bottom: 10px;
            .checkbox {
              line-height: 24px;
              padding: 8px 10px;
              border: 2px solid #ececec;
              border-radius: 5px;
              margin-bottom: 15px;
              &.checked {
                border-color: #397ef5;
              }
              label {
                .num_text {
                  margin-left: 5px;
                }
                .title_text {
                  margin-left: 5px;
                }
              }
            }
            /deep/img {
              max-width: 100%;
            }
            &.check_img_list {
              .checkbox {
                float: left;
                position: relative;
                width: calc(50% - 7.5px);
                padding: 0;
                border-width: 1px;
                border-radius: 8px;
                overflow: hidden;
                &:nth-child(2n + 1) {
                  margin-right: 15px;
                }
                .check_img_box {
                  position: relative;
                  width: 100%;
                  height: 0;
                  padding-bottom: 75%;
                  background-color: #fff;
                  .img {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                    img {
                      display: block;
                      width: 100%;
                      height: 100%;
                    }
                  }
                }
                input[type="checkbox"] {
                  display: none;
                }
                &::after {
                  position: absolute;
                  right: 0;
                  top: -1px;
                  display: block;
                  width: 30px;
                  height: 30px;
                  z-index: 2;
                  background-image: url(~@/assets/images/icon_unselect.png);
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size: contain;
                  content: "";
                }
                &.checked {
                  &::after {
                    background-image: url(~@/assets/images/icon_select.png);
                  }
                }
              }
              .info {
                padding: 5px 12px 5px;
                line-height: 21px;
                .title_text {
                  color: #333;
                  font-size: 14px;
                }
              }
            }
          }
          textarea {
            width: 100%;
            height: 112px;
            line-height: 24px;
            padding: 10px;
            background: #f6f6f6;
            border: 1px solid #eee;
            border-radius: 5px;
            resize: none;
          }
          .fill {
            padding: 5px 0;
            line-height: 24px;
            /deep/.fill_input {
              border: none;
              outline: none;
              border-bottom: 1px solid #000;
            }
          }
          .judge_list {
            border: 1px solid #ececec;
            border-radius: 5px;
            margin-bottom: 10px;
            .judge {
              line-height: 24px;
              padding: 8px 10px;
              &.split_line {
                border-bottom: 1px solid #ececec;
              }
              label {
                .title_text {
                  margin-left: 5px;
                }
              }
            }
          }
        }
      }
    }
    .submit_btn_box {
      padding: 15px;
      background: #fff;
      .submit_btn {
        display: block;
        width: 100%;
        line-height: 32px;
        background: #397ef5;
        border: 1px solid #397ef5;
        border-radius: 3px;
        text-align: center;
        color: #fff;
        font-size: 14px;
      }
    }
  }
  .result_box {
    position: relative;
    .result_score_box {
      position: relative;
      .result_img_box {
        img {
          display: block;
          width: 100%;
        }
      }
      .result_close {
        display: block;
        position: absolute;
        top: 0;
        right: 6%;
        width: 11%;
        height: 10%;
      }
      .result_score {
        display: block;
        position: absolute;
        top: 16%;
        left: 26%;
        width: 34%;
        height: 16%;
        color: #ff6c00;
        text-align: center;
        font-size: 40px;
      }
      .btn_confirm {
        display: block;
        position: absolute;
        top: 80%;
        left: 18%;
        width: 65%;
        height: 12%;
      }
      .btn_raffle {
        display: block;
        position: absolute;
        top: 80%;
        left: 10%;
        width: 37%;
        height: 12%;
      }
      .btn_close {
        display: block;
        position: absolute;
        top: 80%;
        right: 10%;
        width: 37%;
        height: 12%;
      }
    }
    .result_thanks_box {
      .result_img_box {
        img {
          display: block;
          width: 100%;
        }
      }
      .btn_confirm {
        display: block;
        position: absolute;
        top: 75%;
        left: 16%;
        width: 68%;
        height: 16%;
      }
      .btn_raffle {
        display: block;
        position: absolute;
        top: 75%;
        left: 9%;
        width: 38%;
        height: 16%;
      }
      .btn_close {
        display: block;
        position: absolute;
        top: 75%;
        right: 9%;
        width: 38%;
        height: 16%;
      }
    }
  }
}
</style>